export default "__VITE_ASSET__5280b579__"